'use client';
import { useEffect, useState } from 'react';

interface FontLoaderProps {
  proximaNovaVariable: string;
  proximaNovaCondVariable: string;
}

const FontLoader: React.FC<FontLoaderProps> = ({ proximaNovaVariable, proximaNovaCondVariable }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    
    // Apply font classes to html element on client side
    const htmlElement = document.documentElement;
    htmlElement.classList.add(proximaNovaVariable, proximaNovaCondVariable);
    
    return () => {
      // Cleanup on unmount
      htmlElement.classList.remove(proximaNovaVariable, proximaNovaCondVariable);
    };
  }, [mounted, proximaNovaVariable, proximaNovaCondVariable]);

  if (!mounted) {
    return null; // Don't render anything on server
  }

  return null; // This component doesn't render anything
};

export default FontLoader;